import React from 'react'
import { Badge } from '@radix-ui/themes'
import { ClockIcon, CheckCircleIcon } from 'lucide-react'

interface DealStatusProps {
  status: 'late' | 'ontime'
  showLabel?: boolean
  size?: 'small' | 'medium'
}

export const DealStatus: React.FC<DealStatusProps> = ({ status, showLabel = false, size = 'medium' }) => {
  const isLate = status === 'late'

  if (showLabel) {
    return (
      <Badge color={isLate ? 'red' : 'green'} variant="soft" size={size === 'small' ? '1' : '2'}>
        {isLate ? (
          <>
            <ClockIcon size={12} />
            Atrasado
          </>
        ) : (
          <>
            <CheckCircleIcon size={12} />A tiempo
          </>
        )}
      </Badge>
    )
  }

  // Just show colored circle indicator
  return (
    <div
      className={`${size === 'small' ? 'w-3 h-3' : 'w-4 h-4'} rounded-full ${isLate ? 'bg-red-500' : 'bg-green-500'}`}
      title={isLate ? 'Atrasado' : 'A tiempo'}
    />
  )
}
